var render = function render(){var _vm=this,_c=_vm._self._c;return _c('countTo',_vm._b({ref:"countToRef",attrs:{"startVal":_vm.startVal,"endVal":_vm.endVal,"duration":_vm.duration,"autoplay":_vm.autoplay,"decimals":_vm.decimals,"decimal":_vm.decimal,"separator":_vm.separator,"prefix":_vm.prefix,"suffix":_vm.suffix,"useEasing":_vm.useEasing}},'countTo',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }